import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { DashboardTile } from "./DashboardTile";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => {
    return {
        container: {},
        heading: {
            color: "#9f9f9f",
            fontSize: "1.2em",
            fontWeight: 600,
        },
    };
});
export const DashboardSection = ({ section }) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h6", className: classes.heading }, section.title),
        React.createElement(Grid, { container: true, spacing: 3, className: classes.container }, section.tiles.map((tile, index) => {
            return React.createElement(DashboardTile, { key: index, tile: tile });
        }))));
};
